<div *ngIf="loading; else elseBlock" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <ng-template #elseBlock >

    <div style="display: flex;justify-content: space-between;flex-direction: column;height: 100%;">
      <h2>Seleccionar {{data.item.agrupadoInfo.nroPersonasPax[data.file.paxQuantity-1]}} equipo(s) para {{data.item.agrupadoInfo.nombreEquipo +" " +data.item.agrupadoInfo.marcaEquipo+" "+data.item.agrupadoInfo.modeloEquipo }}</h2>

 <!--      <mat-form-field appearance="outline" style="width: 100%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field> -->

    <div class="mat-elevation-z8" *ngIf="dataSource?.data?.length">
      <mat-table [dataSource]="dataSource" matSort >

        <ng-container matColumnDef="Check">

          <mat-header-cell  *matHeaderCellDef>
          <!--             <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()">
            </mat-checkbox> -->
          </mat-header-cell>
          <mat-cell  *matCellDef="let element"><mat-checkbox [checked]="element.selected" (change)="updateCheck(element)">
          </mat-checkbox></mat-cell>
        </ng-container>

        <ng-container matColumnDef="codigo">
          <mat-header-cell  *matHeaderCellDef>CODIGO</mat-header-cell>
          <mat-cell  *matCellDef="let element">{{ element?.codigo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="valoracion">
          <mat-header-cell  *matHeaderCellDef>VALORACIÓN</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.valoracionEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="observacion">
          <mat-header-cell  *matHeaderCellDef>OBSERVACIÓN</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.observacionEquipo }}</mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  *matRowDef="let row; columns: displayedColumns"></mat-row>

      </mat-table>
    </div>
    <mat-paginator *ngIf="dataSource?.data?.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>


    <h3 *ngIf="!dataSource?.data?.length"> No existen equipos {{data.item.agrupadoInfo.nombreEquipo }} en el inventario, por favor crearlos.</h3>

    <div class="button-close" >
      <button mat-raised-button class="buttonPrimary" (click)="closeDialog()">Confirmar</button>
      <button mat-raised-button class="buttonPrimary" (click)="closeDialogAssing()">Cerrar</button>
    </div>
    
    </div>
    
  </ng-template>
